module.exports = __webpack_public_path__ + "img/normal_wild_win.cf5f411f.png";